import React from 'react'
import { Skeleton, Container } from "@usap/widgets/src/components/Skeletons/styles"
import { useResponsiveWrapperContext } from '@usap/uicomponents'

const RecommendationSkeleton = () => {
    const { isDesktop } = useResponsiveWrapperContext()
    return (
        <Container>
            <Skeleton backgroundColor="#d1d5db" width={isDesktop ? "13rem" : "15.625rem"} height={"212px"} borderRadius="4px" marginBottom="12px" isWmoEnabled={true} />
            <Skeleton backgroundColor="#d1d5db" width={isDesktop ? "13rem" : "15.625rem"} height={"64px"} borderRadius="4px" marginBottom="12px" isWmoEnabled={true} />
            <Skeleton backgroundColor="#d1d5db" width={isDesktop ? "11rem" : "13rem"} height={"44px"} borderRadius="4px" marginBottom="12px" isWmoEnabled={true} />
            <Skeleton backgroundColor="#d1d5db" width={"96px"} height={"36px"} borderRadius="4px" marginBottom="28px" isWmoEnabled={true} />
            <Skeleton backgroundColor="#d1d5db" width={"176px"} height={"40px"} borderRadius="4px" isWmoEnabled={true} />
        </Container>
    )
}

export default RecommendationSkeleton
